import { HTTP } from '../../http-common'

export default {
  state: {
    loadedFloors: []
  },
  getters: {
    loadedFloors (state) {
      return state.loadedFloors
    }
  },
  mutations: {
    setLoadedFloors (state, payload) {
      state.loadedFloors = payload
    },
    createFloor (state, payload) {
      state.loadedFloors.push(payload)
    },
    updateFloor (state, payload) {
      state.loadedFloors = state.loadedFloors.map(floor => floor.id === payload.id ? payload : floor)
    },
    removeFloor (state, id) {
      state.loadedFloors = state.loadedFloors.filter(floor => {
        return floor.id !== id
      })
    },
    clearLoadedFloors (state) {
      state.loadedFloors = []
    }
  },
  actions: {
    loadFloors ({ commit }) {
      commit('clearError')
      commit('setLoading', true)
      commit('setLoadedFloors', [])

      return new Promise((resolve, reject) => {
        HTTP.get('floor_type.json')
          .then(result => {
            console.log(result.data)
            commit('setLoadedFloors', result.data.results)
            resolve(result.data)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    createFloor ({ commit, getters }, payload) {
      console.log('createFloor')
      commit('clearError')
      commit('setLoading', true)
      const newFloor = {
        description: payload.description
      }
      return new Promise((resolve, reject) => {
        HTTP.post('floor_type.json/', newFloor)
          .then(result => {
            console.log(result)
            commit('createFloor', result.data)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    updateFloor ({ commit, getters }, payload) {
      console.log('updateFloor')
      commit('clearError')
      commit('setLoading', true)
      const floor = {
        description: payload.description
      }
      return new Promise((resolve, reject) => {
        HTTP.patch(`floor_type.json/${payload.id}/`, floor)
          .then(result => {
            console.log(result)
            commit('updateFloor', result.data)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    removeFloor ({ commit }, payload) {
      console.log('removeFloor')
      commit('clearError')
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        HTTP.delete(`floor_type.json/${payload}`)
          .then(result => {
            console.log('result', result)
            commit('removeFloor', payload)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    clearLoadedFloors ({ commit }) {
      commit('clearLoadedFloors')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/floor/index.js